module.exports = __webpack_public_path__ + "static/media/Olascom L 1.d3ed5f38.png";